import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import {Funcoes} from "../funcoes";
import {Global} from "../global";
import {FichasModel} from "./fichas.model";
import {FichasService} from "./fichas.service";
import { MercadoriasService } from "../mercadorias/mercadorias.service";
import { LoginService } from "../login/login.service";
import { ConfiguracoesService } from "../configuracoes/configuracoes.service";


@Component({
  selector: 'app-visualizar-ficha',
  templateUrl: './visualizar-ficha.component.html'
})
export class VisualizarFichaComponent implements OnInit {

  title: string;
  ficha: FichasModel = new FichasModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  mascaraContainer = [/[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/];

  nomeEmpresa: string = 'TopBridge';
  logoPdfUrl: string = '';

  listViagens = [];
  listMercadorias = [];
  listVariedades = [];
  listUnidades = [];
  listEmbalagens = [];
  listDefeitos = [];
  listIndicesConclusao = [];
  listObservacoes = [];
  listConclusoes = [];
  listOdores = [{"texto": this.func.traduzir('front.odornormal'), "valor": "normal"}, {"texto": this.func.traduzir('front.odorestranho_ao_produto'), "valor": "estranho_ao_produto"}];
  listPressao = [{"texto": this.func.traduzir('front.pressaominima'), "valor": "minima"}, {"texto": this.func.traduzir('front.pressaomaxima'), "valor": "maxima"}, {"texto": this.func.traduzir('front.pressaomedia'), "valor": "media"}];
  listFotos = [];

  conclusoesSelecionadas = [];
  observacoesSelecionadas = [];
  indicesConclusaoSelecionados = [];
  modelIndicesConclusaoSelecionados = []; // guarda os valores selecionados nos indices de conclusao

  pressaoMin: number = null;
  pressaoMax: number = null;
  pressaoMedia: number = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fichasService: FichasService,
    private mercadoriasService: MercadoriasService,
    public loginService: LoginService,
    private _location: Location,
    public func: Funcoes,
    public global: Global,
    private configService: ConfiguracoesService
  ) {

  }

  ngOnInit() {
    this.carregarConfiguracoes();

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }


    let id = this.route.params.subscribe(params => {
      let id = params['id_ficha'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.editarFicha');
      }else{
        this.title = id ? this.func.traduzir('front.visualizarFicha') : this.func.traduzir('front.cadastrarNovaFicha');
      }

      if (!id) {
        return;
      }

      this.fichasService.getById(id, ["observacoes", "conclusoes", "defeitos", "fotos", "importador", "exportador", "terminal", "pais_origem", "despachante", "armador", "viagem", "unidade", "transportador", "mercadoria", "embalagem", "responsaveis_tecnicos"])
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarFicha')+': '+json.Payload[0].numero;
            }else{
              this.title = this.func.traduzir('front.visualizarFicha') + ': ' + json.Payload[0].numero;
            }

            this.ficha = json.Payload[0];
            if (this.ficha && this.ficha.termografos) {
              try {
                if (typeof this.ficha.termografos === 'string') {
                  this.ficha.termografos = JSON.parse(this.ficha.termografos);
                }
              } catch (e) {
                this.ficha.termografos = [];
              }
            } else if (this.ficha) {
              this.ficha.termografos = [];
            }
            this.calcularMinMaxMediaPressao();
            if (this.ficha && this.ficha.defeitos) {
              this.ficha.defeitos = this.ficha.defeitos.filter(d => d.defeito && !d.defeito.is_indice_acumulado);
            }
            this.listFotos = json.Payload[0].fotos;

            let defeitosFicha = json.Payload[0].defeitos;

            console.log('ficha', this.ficha);

            for(let x in this.ficha.observacoes){
              this.observacoesSelecionadas.push(this.ficha.observacoes[x].id_observacao);
            }

            for(let x in this.ficha.conclusoes){
              this.conclusoesSelecionadas.push(this.ficha.conclusoes[x].id_conclusao);
            }

            console.log('observacoesSelecionadas', this.observacoesSelecionadas);
            console.log('conclusoesSelecionadas', this.conclusoesSelecionadas);

            //this.indicesConclusaoSelecionados = this.ficha.indices_conclusao;

            // busca variedades, dedeitos, indices de conclusão e indices de classificacao relacionados a mercadoria
            this.mercadoriasService.getById(this.ficha.id_mercadoria, ["variedades", "defeitos", "indices_conclusao", "indices_classificacao"])
              .subscribe( json => {

                console.log('Variedades e Defeitos e Indices', json.Payload);

                this.listVariedades = json.Payload[0].variedades;

                this.listIndicesConclusao = json.Payload[0].indices_conclusao;

                console.log('Indices', this.listIndicesConclusao);

                for(let j in this.listIndicesConclusao){
                  console.log('indice', this.listIndicesConclusao[j]);


                  let comModelIndice = false;

                  for(let k in this.listIndicesConclusao[j].itens){
                    console.log('itens', this.listIndicesConclusao[j].itens[k]);

                    for(let q in this.ficha.indices_conclusao){
                      console.log(this.listIndicesConclusao[j].nome_pt+' = '+this.ficha.indices_conclusao[q].nome_pt)

                      if(this.listIndicesConclusao[j].nome_pt == this.ficha.indices_conclusao[q].nome_pt){
                        console.log(this.listIndicesConclusao[j].itens[k].nome_pt+' == '+this.ficha.indices_conclusao[q].valor.nome_pt)

                        if(this.listIndicesConclusao[j].itens[k].nome_pt == this.ficha.indices_conclusao[q].valor.nome_pt){
                          console.log('valor selecionado', k);
                          this.modelIndicesConclusaoSelecionados.push(k);
                          console.log('modelIndicesConclusaoSelecionados', this.modelIndicesConclusaoSelecionados);
                          comModelIndice = true;

                          this.indicesConclusaoSelecionados.push({
                            "nome_pt": this.listIndicesConclusao[j].nome_pt,
                            "nome_en": this.listIndicesConclusao[j].nome_en,
                            "nome_es": this.listIndicesConclusao[j].nome_es,
                            "valor": {
                              "nome_pt": this.listIndicesConclusao[j].itens[k].nome_pt,
                              "nome_en": this.listIndicesConclusao[j].itens[k].nome_en,
                              "nome_es": this.listIndicesConclusao[j].itens[k].nome_es
                            }
                          });
                        }

                      }
                    }

                  }

                  if(!comModelIndice){
                    this.modelIndicesConclusaoSelecionados.push(null);
                    this.indicesConclusaoSelecionados.push({
                      "nome_pt": this.listIndicesConclusao[j].nome_pt,
                      "nome_en": this.listIndicesConclusao[j].nome_en,
                      "nome_es": this.listIndicesConclusao[j].nome_es,
                      "valor": {
                        "nome_pt": null,
                        "nome_en": null,
                        "nome_es": null
                      }
                    });
                    console.log('modelIndicesConclusaoSelecionados', this.modelIndicesConclusaoSelecionados);
                  }

                }

                if (json.Payload && json.Payload[0] && json.Payload[0].defeitos) {
                  json.Payload[0].defeitos = json.Payload[0].defeitos.filter(d => !d.is_indice_acumulado);
                }

                // zera defeitos
                this.listDefeitos = [];
                // adiciona defeito por defeito
                for(let x in json.Payload[0].defeitos){

                  let valor = 0.00;

                  for(let z in defeitosFicha){
                    if(defeitosFicha[z].id_defeito == json.Payload[0].defeitos[x].id){
                      valor = defeitosFicha[z].valor;
                    }
                  }

                  this.listDefeitos.push({
                    "id_defeito": json.Payload[0].defeitos[x].id,
                    "nome_pt": json.Payload[0].defeitos[x].nome_pt,
                    "valor": valor
                  });
                }

              });

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });

  }

  voltar() {
    this._location.back();
  }

  gerarPDF(id){
 
  }

  calcularMinMaxMediaPressao() {
    if (this.ficha && this.ficha.pressao_polpa) {
      let pressaoData = typeof this.ficha.pressao_polpa === 'string' ? JSON.parse(this.ficha.pressao_polpa) : this.ficha.pressao_polpa;
      if (Array.isArray(pressaoData) && pressaoData.length > 0) {
        let validValues = [];
        pressaoData.forEach(val => {
          if (val !== null && val !== undefined && val !== '') {
            let valFloat = typeof val === 'string' ? parseFloat(val.replace(',', '.')) : parseFloat(val);
            if (!isNaN(valFloat) && isFinite(valFloat)) {
              validValues.push(valFloat);
            }
          }
        });
        if (validValues.length > 0) {
          this.pressaoMin = Math.min(...validValues);
          this.pressaoMax = Math.max(...validValues);
          let sum = validValues.reduce((a, b) => a + b, 0);
          this.pressaoMedia = sum / validValues.length;
        } else {
          this.pressaoMin = null;
          this.pressaoMax = null;
          this.pressaoMedia = null;
        }
      } else {
        this.pressaoMin = null;
        this.pressaoMax = null;
        this.pressaoMedia = null;
      }
    } else {
      this.pressaoMin = null;
      this.pressaoMax = null;
      this.pressaoMedia = null;
    }
  }

  formatTemp(val: number): string {
    if (val === null || isNaN(val)) return '***';
    return val.toFixed(2).replace('.', ',');
  }

  carregarConfiguracoes() {
    this.configService.getConfiguracoes().subscribe(
      (json: any) => {
        if (json && json.Payload && json.Payload.length > 0) {
          let item = Array.isArray(json.Payload[0]) ? json.Payload[0][0] : json.Payload[0];
          if (item) {
            if (item.nome_empresa) this.nomeEmpresa = item.nome_empresa;
            if (item.logo_pdf) {
              this.logoPdfUrl = item.logo_pdf.startsWith('http') ? item.logo_pdf : this.global.dominio_site + item.logo_pdf;
            }
          }
        }
      },
      error => {}
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/fichas/visualizar-ficha.component.ts